// extracted by mini-css-extract-plugin
export var button = "_x-0";
export var buttonContent = "_x-e";
export var buttonGroup = "_x-c";
export var dontRestrainIconWidth = "_x-a";
export var dropdownButton = "_x-b";
export var iconContainer = "_x-9";
export var lg = "_x-4";
export var md = "_x-3";
export var pending = "_x-f";
export var sm = "_x-2";
export var spinner = "_x-d";
export var squared = "_x-8";
export var wrapText = "_x-g";
export var xl = "_x-5";
export var xs = "_x-1";
export var xxl = "_x-6";
export var xxxl = "_x-7";